<template>
  <div>
    <v-app-bar app color="white" :dense="$route.name == 'TicketScan'" v-if="$route.name != 'tv'">
      <v-app-bar-nav-icon v-if="true" @click.stop="clickNavIcon"></v-app-bar-nav-icon>
      <change-systems></change-systems>
      <v-toolbar-title>
          <router-link to="/">
            <v-img :src='logoCimentao' class="" contain height="40" width="120"></v-img>
          </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <view-as-role-chip></view-as-role-chip>
      <module-chip class="ml-2"></module-chip>
    </v-app-bar>
  </div>
</template>
<script>
import resize from "@/mixins/resize";
import { mapMutations, mapState } from "vuex";
import CimentaoLogo from '../../assets/logos/cimentao.png';

export default {
  components: {
    SideBar: () => import("./_drawer_01"),
    ChangeSystems: () => import("@/components/shared/ChangeSystems.vue"),
    ModuleChip: () => import("@/_backoffice/_registrations/components/shared/ModuleChip.vue"),
    ViewAsRoleChip: () => import("@/components/shared/ViewAsRoleChip.vue"),
  },
  mixins: [resize],
  data() {
    return {
      logoCimentao: CimentaoLogo,
      show_side_bar: false,
      links:[],
    };
  },
  computed: {
    ...mapState({
      profile: state=>state.User.oneUser,
    })
  },
  methods: {
    setLinks(){
      let links = [] //[...this.links]
      if(this.profile?.employee?.role){
        const ROLE = this.profile.employee.role
  
        this.links.forEach(el => {
          if (el.roles && el.roles.length){
            if ( el.roles.includes(ROLE) ) {
              if ( el.children && el.children.length ){
                let c = el.children.filter(child => child.roles.includes(ROLE))
                links.push({...el, children: c})
              } else{
                links.push(el)
              }
            }
          } else {
            links.push(el)
          }
        });
        
        this.links = [...links]
      }
    },
    clickNavIcon() {
      this.setDrawer(!this.$store.state.App.drawer);
    },
    ...mapMutations({
      setDrawer: "App/setDrawer"
    }),
  },
  mounted () {
    this.setLinks()
  },


  watch: {
    profile(nv,ov) {
      if (nv){
        this.setLinks()
      }
    }
  },
};
</script>

<style scoped>

.logo{
  width: 120px !important;
  height: auto;
  margin-top: 10px;
}

</style>